import { z } from 'zod'

import type {
  CommonResponseSliceTeacherResponse,
  CommonResponseTeacherResponse,
  GetTeachersInAcademyData,
  TeacherActivityResponse,
} from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'
import { mapSliceContent, type Slice, sliceSchema } from '~/schema/slice'

import {
  type Teacher,
  type TeacherActivityCount,
  TeacherActivityCountSchema,
  type TeacherInAcademy,
  TeacherInAcademySchema,
  TeacherSchema,
} from './schemas'

const ENTITY = 'Teacher'

export const adaptTeachers = (raw: CommonResponseSliceTeacherResponse['data']): Slice<Teacher> =>
  mapSliceContent(parseApiResponse(sliceSchema(TeacherSchema), raw, ENTITY), (teacher) => teacher)

export const adaptTeacher = (raw: CommonResponseTeacherResponse['data']): Teacher =>
  parseApiResponse(TeacherSchema, raw, ENTITY)

export const adaptTeacherActivityCount = (raw: TeacherActivityResponse): TeacherActivityCount =>
  parseApiResponse(TeacherActivityCountSchema, raw, ENTITY)

export const adaptTeachersInAcademy = (raw: GetTeachersInAcademyData): TeacherInAcademy[] =>
  parseApiResponse(z.object({ teachers: z.array(TeacherInAcademySchema) }), raw, ENTITY)
    ?.teachers ?? []
